import {
  checkProductLength,
  getCartItemsCookie,
  getRandomEventId,
  getScreenName,
  replacePriceSymbol,
} from '../../../Utils/helper';
import {
  fireFbAddToCart,
  getPriceParams,
} from '../../../Utils/productPageUtils';

import { fireEvent } from '../../../Utils/fireEvent';

export const firePopupEvent = (productData, categoryName, offerCode) => {
  fireEvent({
    category: categoryName,
    screen_name: 'cloth_diapers_page',
    id: productData?._id,
    sku_name: productData?.name,
    selling_price: productData?.price,
    sku_nickname: productData?.nickname,
    pdp_variant: productData?.variantType,
    page_url: window.location.href.slice(0, 98),
    parent: `${offerCode}_popup`,
  });
};
export const fireAddProductEvent = (
  productData,
  addedId,
  offerCode,
  selectButton,
) => {
  const productCopy = { ...productData };
  productCopy.price = replacePriceSymbol(productData?.price);
  productCopy.strikePrice = replacePriceSymbol(productData?.strikePrice);
  const { pricingParam, conversionParam } = getPriceParams(productCopy);
  const RandomEventId = getRandomEventId();
  fireFbAddToCart(productCopy, RandomEventId);
  const nickname = productCopy?.nickname
    ? checkProductLength(productCopy?.nickname)
    : checkProductLength(productCopy?.name);
  fireEvent({
    category: 'clicked_add_to_cart',
    screen_name: 'cloth_diapers_page',
    id: productCopy?._id || productCopy?.id,
    sku_name: productCopy?.name,
    selling_price: productCopy?.price,
    sku_nickname: nickname,
    pdp_variant: productCopy?.variantType,
    page_url: window.location.href.slice(0, 98),
    parent: `${offerCode}_popup`,
    sku_added: addedId,
    pricing_param: pricingParam,
    conversion_param: conversionParam,
    cta: selectButton ? 'select this diaper' : 'Add',
    selected_option: 'B2g1',
    event_id: RandomEventId,
  });
};

export const fireUpdateQuantityEvent = (
  productData,
  cta,
  quantity,
  offerCode,
  addedId,
) => {
  const { pricingParam } = getPriceParams(productData);
  fireEvent({
    category: 'update_quantity',
    screen_name: 'cloth_diapers_page',
    id: productData?._id,
    pricing_param: pricingParam,
    parent: `${offerCode}_popup`,
    cta: cta,
    support_variable: quantity,
    sku_added: addedId,
    selected_option: 'B2g1',
  });
};

export const fireProceedToCartEvent = (productData, offerCode) => {
  fireEvent({
    category: 'clicked_go_to_cart',
    screen_name: 'cloth_diapers_page',
    id: productData?.id,
    sku_name: productData?.name,
    selling_price: productData?.price,
    sku_nickname: productData?.nickname,
    pdp_variant: productData?.variantType,
    page_url: window.location.href.slice(0, 98),
    parent: `${offerCode}_popup`,
    sku_added: getCartItemsCookie(),
    selected_option: 'B2g1',
  });
};
export const fireClickedOptionEvent = (type, offerCode) => {
  fireEvent({
    category: 'clicked_option',
    option: type,
    screen_name: getScreenName(),
    parent: `${offerCode}_popup`,
  });
};
